//React
import React from 'react';
import {
  Link
} from "react-router-dom";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action

import * as partnerOperationAction from '../action/partnerOperationAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Avatar from '@material-ui/core/Avatar';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
//Add
import Blank from '../img/blank/blank-1x1.gif';
//Icon
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';
//Part
import PartUserMainImg from './PartUserMainImg';
import PartUserName from './PartUserName';

class Comp extends React.Component {

  _renderList(value, index) {
    return (
      <div key={index} className='item' align='center' style={{position:'relative'}}>

        <div style={{margin:'5px'}}>

          <Link to={{pathname: '/partner/' + value.userdata_id_code}}>
            <PartUserMainImg
              mainImg={value.userdata_mainImg}
              width={'100%'}
              height={'auto'}
              radius={'50%'}
            />
          </Link>

          <div style={{padding:'0px'}}>
            <Link to={{pathname: '/partner/' + value.userdata_id_code}}>
              <PartUserName
                data={{
                  name: value.userdata_name,
                  sex: value.userdata_sex,
                  size: '0.8em',
                }}
              />
            </Link>

            <div style={{fontSize:'0.7em', color:'#666'}} >
              {value.userdata_age}才 {value.userdata_region}
            </div>
          </div>
        </div>
        <div style={{position:'absolute', top:'0px', right:'0px'}}>
          <IconButton
            size='small'
            onClick={ () => this.props.partnerOperationOpen(value.userdata_id_code, ['footprintPartnerDel', 'memo', 'refusal']) }
          >
            <MoreVertSharpIcon />
          </IconButton>
        </div>
      </div>

    )
  }


	render() {
		return (
			<div className='footprint_block'>
        {
          (this.props.my.proof.credit === 0 && this.props.my.proof.person === 0) ? (
            <div>
              <div align='center' style={{color:'#666'}}>
                <div>本人証明を申請すると「足あと」が表示されます</div>
              </div>

              <div align='center' style={{padding:'5px'}}>
                <div style={{display:'inline-block', position:'relative'}}>
                  <AvatarGroup spacing='small' max={100}>
                  {
                    (this.props.list.length > 0) &&
                    this.props.list.filter(value => value.userdata_mainImg.src !== null).map(
                      (value, index) => {
                        return (
                          <Avatar
                            key={index}
                            src={value.userdata_mainImg.src}
                          />
                        )
                      }
                    )
                  }
                  </AvatarGroup>
                  <img
                    src={Blank}
                    style={{
                      position:'absolute',
                      left:0,
                      top:0,
                      width:'100%',
                      height:'100%',
                      zIndex:10000
                    }}
                    alt=''
                  />
                </div>
                <div>
                  <Link to={{pathname: '/my/proof/person'}}>
                    <Button
                      variant="outlined"
                      color='secondary'
                    >
                      本人証明を申請する
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          ): (
            <div className='inner'>
              {
                (this.props.list.length > 0) &&
                this.props.list.map((value, index) =>
                  this._renderList(value, index)
                )
              }
            </div>
          )
        }
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({

    ...partnerOperationAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
